const images = {
  logoSapienza: require("./logo-sapienza.png"),
};

export default images;
